module.exports = "[hidden] { display: none; }\n"